// extracted by mini-css-extract-plugin
export default {"link":"_32JEK"};